export default "__VITE_ASSET__Cm3$No9W__"